function scrollToElement ( id ) {

    const scrollToElement = document.getElementById( id );
    scrollToElement.scrollIntoView( { behavior: "smooth" } );
    return;

}
